import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/advertiser/transaction/list' // 광고목록 조회

const fetchKey = (page, maxData, type) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${type !== 0 ? ('&type=' + type) : ''}`;

export function useAdvertiserTransactionList(page, maxData, type) {
	const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, type);

		console.log('//maxData',maxData && '&maxData=' + maxData)
		console.log('//KEY',KEY)
	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { advertiserTransactionList: data?.list, mutateAdvertiserTransactionList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Advertiser Transaction List:', error);
		return { list: [], total: 0 };
	}
}